<script setup lang="ts">
/**
 * v-model select carrying the canonical builder select classes. Options go in the
 * default slot (`<option>` children). `size="sm"` → h-9 text-sm; `size="xs"` → h-8 text-xs.
 */
const props = withDefaults(defineProps<{
  modelValue?: string | null
  size?: 'sm' | 'xs'
}>(), {
  size: 'sm',
})

defineEmits<{ 'update:modelValue': [value: string] }>()

const sizeClass = computed(() =>
  props.size === 'xs' ? 'h-8 px-2.5 text-xs' : 'h-9 px-3 text-sm',
)
</script>

<template>
  <select
    :value="modelValue ?? ''"
    :class="sizeClass"
    class="w-full rounded-md border border-input bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    @change="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
  >
    <slot />
  </select>
</template>
